import CustomerCreateActionModal from './CustomerCreateActionModal';

export default CustomerCreateActionModal;
